import EADialog from "components/common/EADialog";
import useStyles from "./EsgScoreModalStyle";
import i18next from "i18next";
import ClassificationEsgScore from "./ClassificationEsgScore";
import { convert } from "html-to-text";
import TopicExamplesTooltip from "./TopicExamplesTooltip";

const EnvironmentalScoreModal = ({dataESG, esgDetailsContent, isOpen, onClose}) => {
    const {classes} = useStyles();

    if(!esgDetailsContent) {
        return <></>
    }

    const formatThemeScore = (value) => {
        return value?.substring(value?.indexOf(":")+1, value?.length)
    }

    return (
        <EADialog isOpen={isOpen && esgDetailsContent} onClose={onClose} title={i18next.t("ESG.subjectEnvionmentalData")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>

                {dataESG?.environmentalRankingScore &&
                    <div>
                        <div className={classes.subTitle}>{esgDetailsContent["classification_title"]}</div>
                        <ClassificationEsgScore esgDetailsContent={esgDetailsContent} score={String(dataESG?.environmentalRankingScore)} />
                    </div>
                }

                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["depth_scores_title"]}</div>
                    <div className={classes.flex}>
                        <div className={classes.score_bold}>{esgDetailsContent["environmental_depth"]}</div>
                        <div className={classes.depthDescription}>{convert(esgDetailsContent["e_data_depth_description"])}</div>
                    </div>

                </div>
            </div>
        <table className={classes.table_scores}>
            <thead>
                <tr className={classes.table_scores_header}>
                    <th>{i18next.t("ESG.theme")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th className={classes.topicWidth}>{i18next.t("ESG.topic")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th>{esgDetailsContent["table_header_description"]}</th>
                </tr>
            </thead>
            <tbody>
                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["emissions_climate_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["emissions_climate_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["climate_risk_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["climate_risk_score"]}</td>
                    <td>{esgDetailsContent["climate_risk_description"]} <TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["climate_risk_examples"]}/></td>
                </tr>

                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["ghg_emissions_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["ghg_emissions_score"]}</td>
                    <td>{esgDetailsContent["ghg_emissions_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["ghg_emissions_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["natural_resources_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["natural_resources_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["energy_management_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["energy_management_score"]}</td>
                    <td>{esgDetailsContent["energy_management_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["energy_management_examples"]}/></td>
                </tr>

                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["land_use_biodiversity_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["land_use_biodiversity_score"]}</td>
                    <td>{esgDetailsContent["land_use_biodiversity_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["land_use_biodiversity_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["material_sourcing_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["material_sourcing_score"]}</td>
                    <td>{esgDetailsContent["material_sourcing_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["material_sourcing_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["pollution_prevention_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["pollution_prevention_score"]}</td>
                    <td>{esgDetailsContent["pollution_prevention_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["pollution_prevention_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["waste_hazards_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["waste_hazards_score"]}</td>
                    <td>{esgDetailsContent["waste_hazards_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["waste_hazards_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["water_management_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["water_management_score"]}</td>
                    <td>{esgDetailsContent["water_management_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["water_management_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["environmental_opportunities_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["environmental_opportunities_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["environmental_certifications_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["environmental_certifications_score"]}</td>
                    <td>{esgDetailsContent["environmental_certifications_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["environmental_certifications_examples"]}/></td>
                </tr>

                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["environmental_opportunities_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["environmental_opportunities_score"]}</td>
                    <td>{esgDetailsContent["environmental_opportunities_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["environmental_opportunities_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["environmental_risk_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["environmental_risk_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["environmental_compliance_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["environmental_compliance_score"]}</td>
                    <td>{esgDetailsContent["environmental_compliance_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["environmental_compliance_examples"]}/></td>
               
                </tr>

            </tbody>
            </table>
            
        </EADialog>
    )
}
export default EnvironmentalScoreModal